document.addEventListener('DOMContentLoaded', function() {
    const seoText = document.querySelector('.main-collection-seo-text');
    const seoTextHeight = seoText.offsetHeight;
    const seoTextLineHeight = 24;
    const seoTextMaxHeight = seoTextLineHeight * 8;
    if (seoTextHeight > seoTextMaxHeight) {
        seoText.classList.add('main-collection-seo-text--collapsed');
        // also add a read more button to expand the text
        const readMoreButton = document.createElement('button');
        readMoreButton.classList.add('main-collection-seo-text-read-more', 'button', 'button--regular', 'button--outline');
        readMoreButton.textContent = 'Lees meer';

        seoText.querySelector('.rich-text__text').appendChild(readMoreButton);
        const cardText = document.querySelector('.main-collection-seo-text .rich-text__text .card__text');
        cardText.style.maxHeight = seoText.classList.contains('main-collection-seo-text--collapsed') ? seoTextMaxHeight + 'px' : seoTextHeight + 'px';
        readMoreButton.addEventListener('click', function() {
            seoText.classList.toggle('main-collection-seo-text--collapsed');
            if (seoText.classList.contains('main-collection-seo-text--collapsed')) {
                readMoreButton.textContent = 'Lees meer';
            } else {
                readMoreButton.textContent = 'Lees minder';
            }

            const cardText = document.querySelector('.main-collection-seo-text .rich-text__text .card__text');
            cardText.style.maxHeight = seoText.classList.contains('main-collection-seo-text--collapsed') ? seoTextMaxHeight + 'px' : seoTextHeight + 'px';
        });
    }
});